<ng-container *ngIf="notifications$ | async as notifications">
  <div class="notification-modal" [class.settings-mode]="showSettings" [class.empty-mode]="!showSettings && notifications.length === 0" [class.few-notifications]="!showSettings && notifications.length > 0 && notifications.length <= 4">
    <div class="modal-top-section" *ngIf="!showSettings">
    <div class="header-row">
      <div class="header-left">
        <h2>Notifications</h2>
        <button mat-button (click)="showSettingsView()" class="settings-btn">
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </button>
      </div>
      <button mat-icon-button (click)="close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="toggle-row">
      <span>Only show unread</span>
      <mat-slide-toggle [ngModel]="filterSubject.value.showOnlyUnread" (ngModelChange)="onToggleChange($event)">
      </mat-slide-toggle>
    </div>
    
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange({index: $event})">
      <mat-tab label="All"></mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fa-solid fa-at"></i>
          <span>Mentions</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fa-solid fa-circle-user"></i>
          <span>Assigned</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fa-solid fa-right-left"></i>
          <span>Status Changes</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="modal-top-section settings-top-section" *ngIf="showSettings">
    <div class="back-row">
      <button class="back-btn" (click)="showNotificationsView()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Notifications</span>
      </button>
      <h2>Notification Settings</h2>
      <button mat-icon-button (click)="close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

    <div class="modal-content" *ngIf="!showSettings">
      <div class="empty-state" *ngIf="notifications.length === 0">
        <p class="empty-message">You have no unread notifications</p>
      </div>

      <ng-container *ngIf="notifications.length > 0">
        <div class="notifications-list">
          <div *ngFor="let notification of notifications" 
             class="notification-item"
             (click)="onNotificationClick(notification)">
          
          <div class="notification-icon">
            <i [class]="'fa-solid ' + getNotificationIcon(notification.type)"></i>
          </div>
          
          <div class="notification-content">
            <div class="notification-header">
              <span class="user-action" [innerHTML]="formatNotificationText(notification)"></span>
              <span class="time">{{getTimeAgo(notification.createdAt)}}</span>
            </div>
            
            <div class="notification-details">
              <div class="entity-title">{{notification.entityTitle}}</div>
              <div class="metadata">
                <div class="metadata-row">
                  <span class="metadata-item">
                    <mat-icon>badge</mat-icon>
                    <span class="value">{{notification.driverId}}</span>
                  </span>
                  <span class="metadata-item">
                    <mat-icon>location_on</mat-icon>
                    <span class="value">{{notification.terminal}}</span>
                  </span>
                </div>
                <div class="metadata-row">
                  <span class="id-status">{{notification.userFriendlyId}} - {{notification.status}}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="unread-indicator" *ngIf="!notification.isRead"></div>
          </div>
        </div>

        <div class="modal-footer">
          <button mat-raised-button class="mark-all-read-btn" (click)="markAllAsRead()">Mark all as read</button>
        </div>
      </ng-container>
    </div>

    <div class="modal-content settings-content" *ngIf="showSettings">
      <app-notification-modal-settings></app-notification-modal-settings>
    </div>
  </div>
</ng-container>